module.exports = __webpack_public_path__ + "media/images/rails-07db7c58.png";